import React, {useEffect, useState} from 'react';
import AuditTrailsList from './AuditTrailsList';
import './AuditTrails.scss';

const AuditTrails = (props) => {
  const {activeRisk, id} = props;
  const [auditAdded, setAuditAdded] = useState(0);
  useEffect(() => {}, [auditAdded, activeRisk]);
  return (
    <div className="document-audits h-100">

        <AuditTrailsList
        activeRisk={activeRisk}
        auditAdded={auditAdded}
        key={'auditList'}
        id={id}
      />
      
    </div>
  );
};

export default AuditTrails;